import React, { useEffect, useState } from 'react';

import "./CourseContent.css"
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';
import "./Courses"
const CourseContent = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id")



    const [courseContent, setCourseContent] = useState<any>()
    const [userProgressCount, setUserProgressCount] = useState<any>()
    const [courseLessonsCount, setCourseLessonsCount] = useState<any>()


    useEffect(() => {
        Swal.showLoading();
        axios.post(`${BASE_URL}/course/getcourse.php`, { id: id }).then((res: any) => {
            setCourseLessonsCount(res.data.data.course_content.length)
            let results = res.data.data.course_content?.reduce(function (results: any, lesson: any) {
                (results[lesson.module_id] = results[lesson.module_id] || []).push(lesson);
                return results;
            }, {})
           
            setCourseContent(results)
            setUserProgressCount(res.data.data.user_progress_count)
            Swal.close()
        }).catch((error)=>{
           
            Swal.fire("Error" , error.response.data.msg , "error").then(() => {
                navigate("/")
            })
        })
    }, [])
    const navigate = useNavigate();

    const handleLessonClick = (lesson:any)=>{
        axios.post(`${BASE_URL}/course/setlastlesson.php`, { lesson_id : lesson.lesson_id }).then((res: any) => {

            navigate(`/lesson?id=${lesson.lesson_id}&module_id=${lesson.module_id}`)
        }).catch((err: any) => {

        })
       
    }
    return (
        <div className="row">
            <div className="col-6">




                {

                    typeof courseContent == "object" ? (
                        Object.keys(courseContent)?.map(function (key) {
                            console.log(courseContent[key])

                            return (
                                <div className="module_container">
                                    <div className="module_name">  {courseContent[key][0]?.module_name} </div>
                                    {courseContent[key]?.map((lesson: any) => {
                                        return (

                                            <div className="lesson_container row mb-5" onClick={() => { handleLessonClick(lesson) }}>
                                                <div className=" lesson_image col-3">

                                                    <img 
                                                     style={{height: "150px !important"}}
                                                    src={`${BASE_URL}/images/${lesson?.lesson_image_path}`}/>
                                                </div>
                                                <div className="col-9 d-flex align-items-center justify-content-between" >

                                                    {lesson.lesson_name} 

                                                    {lesson.status == "c" ? (<div className="text-right" > <FontAwesomeIcon icon={faCheck}/></div>) : null}
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            )

                        })
                    ) : null

                }


            </div>



            <div className="col-6">
                <div className="card" style={{ width: "25rem" }}>
                    <img className="card-img-top" src={`${BASE_URL}/images/instructorhanan.jpg`} alt="Card image cap" />
                    <div className="card-body">
                        <h5 className="card-title">{userProgressCount} of {courseLessonsCount} Lessons Completed</h5>

                    </div>
                </div>


                <div className="card mt-5" style={{ width: "25rem" }}>
                    <div className="card-body">
                        <h5 className="card-title">Instructor </h5>
                        <div className="row">

                            <div className=" lesson_image col-3 ">

                                <img src={`${BASE_URL}/images/instructorhanan.jpg`} />
                            </div>
                            <div className="col-6 d-flex align-items-center" >

                                <h6 className="card-subtitle mb-2 text-muted">Hanan Zain</h6>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}



export default CourseContent